import React from 'react';

import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

export interface EditPipelinePopupProps {
  open: boolean;
  name: string;
  description: string;
  error: string | null;
  onChangeName: (value: string) => void;
  onChangeDescription: (value: string) => void;
  onClose: () => void;
  onSave: () => void;
}

export const EditPipelinePopup: React.FC<EditPipelinePopupProps> = ({
  open,
  name,
  description,
  error,
  onChangeName,
  onChangeDescription,
  onClose,
  onSave,
}) => {
  if (!open) return null;

  return (
    <div className="absolute inset-0 pointer-events-none">
      <div className="h-full w-full flex justify-end">
        <div className="pointer-events-auto h-full w-full max-w-md border-l border-border bg-background">
          <div className="h-14 border-b border-border flex items-center justify-between px-6">
            <div className="text-lg font-semibold">Edit pipeline</div>
            <Button variant="ghost" size="sm" onClick={onClose} aria-label="Close">
              ✕
            </Button>
          </div>

          <div className="p-6 overflow-auto h-[calc(100%-3.5rem)]">
            <div className="space-y-3">
              <div className="space-y-1">
                <div className="text-sm font-medium">Name</div>
                <Input value={name} onChange={(e) => onChangeName(e.target.value)} placeholder="Pipeline name" />
              </div>

              <div className="space-y-1">
                <div className="text-sm font-medium">Description</div>
                <Input
                  value={description}
                  onChange={(e) => onChangeDescription(e.target.value)}
                  placeholder="Optional description"
                />
              </div>

              {error ? <div className="text-sm text-destructive">{error}</div> : null}

              <div className="flex gap-2 pt-2">
                <Button variant="secondary" size="sm" onClick={onSave}>
                  Save
                </Button>
                <Button variant="ghost" size="sm" onClick={onClose}>
                  Cancel
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
